import { HttpResponse } from "@angular/common/http";
import { saveAs } from 'file-saver';

export function downloadFile(response: HttpResponse<Blob>) {
  const body = response.body;
  const contentType = response.headers.get('Content-Type');
  const blob = new Blob(body ? [body] : undefined, {type: contentType ?? undefined});
  const r = /filename="(.+)"/;
  const contentDisposition = response.headers.get('content-disposition');
  const filename = r.exec(contentDisposition ?? '')?.at(1);
  saveAs(blob, filename);
}
